export default class LayoutMobile {

    /** @var {Window} */
    _window;

    constructor(window) {
        this._window = window;
    }

    boot() {
        this._bootBurgerToggle();
        this._bootUserAccountMenu();
    }

    _bootBurgerToggle() {
        this._window.document.addEventListener("click", (e) => {

            if (e.target.matches("a")) {
                return;
            }

            const target = e.target.closest(".burger__sections > li");

            if (!target) {
                return;
            }

            if (target.classList.contains("selected")) {
                target.classList.remove("selected");
            } else {
                const openedMenu = this._window.document.querySelector(".burger__sections > li.selected");
                if (openedMenu) {
                    openedMenu.classList.remove("selected");
                }

                target.classList.add("selected");
            }
        });
    }

    _bootUserAccountMenu() {
        const { lpauth } = window;
        const toggleTriggerElement = this._window.document.querySelector(".burger__userAccount");
        const toggledElement = this._window.document.querySelector(".userAccountWidget__popin");

        if (toggleTriggerElement && toggledElement) {
            if (lpauth && !lpauth.isAuthReady()) {
                toggleTriggerElement.classList.add("burger__userAccount--state-hidden");
                lpauth.onAuthReady(() => toggleTriggerElement.classList.remove("burger__userAccount--state-hidden"));
            } else {
                toggleTriggerElement.classList.remove("burger__userAccount--state-hidden");
            }

            this._window.document.addEventListener("click", (e) => {
                const authReady = lpauth ? lpauth.isAuthReady() : true;

                if (toggledElement.contains(e.target) || !authReady) {
                    return;
                }

                if (toggleTriggerElement.contains(e.target)) {
                    toggleTriggerElement.classList.toggle("burger__userAccount--state-open");
                } else {
                    toggleTriggerElement.classList.remove("burger__userAccount--state-open");
                }
            });
        }
    }

}
